import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { clearMessages, getBotsList, setSelectedBot } from '@/store/chat/actions';

import {
  selectBotSettingsErrors,
  selectBotSettingsLoading,
  selectBotsList,
  selectSelectedBot,
} from '@/store/chat/selectors';

import { Avatar, Button, message, Select, Spin } from 'antd';
import { RobotOutlined, SettingOutlined } from '@ant-design/icons';

import BotSettingsModal from '../BotSettingsModal';

import PropTypes from 'prop-types';

import styles from './BotSelector.module.scss';

const { Option } = Select;

const BotSelector = ({ placeholder = 'Выберите бота', size = 'default', disabled = false }) => {
  const dispatch = useDispatch();

  const botsList = useSelector(selectBotsList);
  const selectedBot = useSelector(selectSelectedBot);
  const loading = useSelector(selectBotSettingsLoading);
  const errors = useSelector(selectBotSettingsErrors);

  const [settingsModalVisible, setSettingsModalVisible] = useState(false);

  useEffect(() => {
    if (botsList.length === 0) {
      dispatch(getBotsList());
    }
  }, [dispatch, botsList.length]);

  // Handle errors
  useEffect(() => {
    if (errors.getBotsList) {
      message.error('Не удалось загрузить список ботов');
    }
  }, [errors.getBotsList]);

  useEffect(() => {
    if (!selectedBot && botsList.length > 0) {
      dispatch(setSelectedBot(botsList[0]));
      console.log(botsList);
    }
  }, [selectedBot, botsList, dispatch]);

  const handleBotSelect = botId => {
    const bot = botsList.find(b => b.botId === botId);
    if (bot && bot.botId !== selectedBot?.botId) {
      // Очищаем предыдущую историю сообщений при переключении на другого бота
      dispatch(clearMessages());
      dispatch(setSelectedBot(bot));
    }
  };

  const handleSettingsClick = () => {
    setSettingsModalVisible(true);
  };

  const handleSettingsClose = () => {
    setSettingsModalVisible(false);
  };

  const renderBotOption = bot => (
    <div className={styles.botOption}>
      <Avatar size='small' src={bot.photo} icon={<RobotOutlined />} className={styles.botAvatar} />
      <div className={styles.botInfo}>
        <div className={styles.botName}>{bot.botName}</div>
      </div>
    </div>
  );

  return (
    <div className={styles.botSelector}>
      <Select
        placeholder={placeholder}
        value={selectedBot?.botId}
        onChange={handleBotSelect}
        loading={loading.getBotsList}
        disabled={disabled || loading.getBotsList}
        size={size}
        className={styles.select}
        dropdownClassName={styles.dropdown}
        showSearch
        filterOption={(input, option) => {
          const bot = botsList.find(b => b.botId === option.value);
          return (
            bot?.botName.toLowerCase().includes(input.toLowerCase()) ||
            bot?.botDescription?.toLowerCase().includes(input.toLowerCase())
          );
        }}
        notFoundContent={
          loading.getBotsList ? (
            <div className={styles.loadingContent}>
              <Spin size='small' />
              <span style={{ marginLeft: 8 }}>Загрузка ботов...</span>
            </div>
          ) : (
            'Боты не найдены'
          )
        }
      >
        {botsList.map(bot => (
          <Option key={bot.botId} value={bot.botId}>
            {renderBotOption(bot)}
          </Option>
        ))}
      </Select>
      <Button type='primary' icon={<SettingOutlined />} onClick={handleSettingsClick} className={styles.settingsButton}>
        Настройки
      </Button>
      <BotSettingsModal open={settingsModalVisible} onCancel={handleSettingsClose} />
    </div>
  );
};

BotSelector.propTypes = {
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(['small', 'default', 'large']),
  disabled: PropTypes.bool,
};

export default BotSelector;
